import { useQuery } from "@tanstack/react-query";
import { cdFetch, cdPost } from "../api";
import { queryKeys } from "../queryKeys";

export const useCrossellFilters = (
  l1: Array<any> | null,
  l2: Array<any> | null,
  l3: Array<any> | null,
  l4: Array<any> | null
) => {
  const { data, isLoading }: any = useQuery({
    queryKey: [queryKeys.reportFilters, l1, l2, l3, l4],
    queryFn: () => getCrossellFilters(l1, l2, l3, l4),
    staleTime: 20000,
  });
  const crossellFilters = { ...data?.data };
  return { crossellFilters, isLoading };
};

export function getCrossellFilters(
  l1: Array<any> | null,
  l2: Array<any> | null,
  l3: Array<any> | null,
  l4: Array<any> | null
) {
  let payload = {
    l1: l1,
    l2: l2,
    l3: l3,
    l4: l4,
  };

  const res = cdPost(`/getAllFiltersCrossSell`, payload);
  return res;
}

export const useCrossSellData = (
  l1: Array<any> | null,
  l2: Array<any> | null,
  l3: Array<any> | null,
  l4: Array<any> | null,
  itemid: string | null,
  customer: string | null,
  pageNumber: number,
  pageSize: number,
  selectedPriority: string | null,
  refreshStatus: boolean | false,
) => {
  const { data, isLoading }: any = useQuery({
    queryKey: [
      queryKeys.reports,
      l1,
      l2,
      l3,
      l4,
      itemid,
      customer,
      pageNumber,
      pageSize,
      selectedPriority,
      refreshStatus,
    ],
    queryFn: () =>
      getReportFiltersData(
        l1,
        l2,
        l3,
        l4,
        itemid,
        customer,
        pageNumber,
        pageSize,
        selectedPriority,
      ),
    staleTime: 20000,
  });
  let crossellData = data?.data?.data ;

  return { crossellData, isLoadingReportData: isLoading };
};

export function getReportFiltersData(
  l1: Array<any> | null,
  l2: Array<any> | null,
  l3: Array<any> | null,
  l4: Array<any> | null,
  itemid: string | null,
  customer: string | null,
  pageNumber: number,
  pageSize: number,
  selectedPriority: string | null,
) {
  let payload = {
    l1: l1,
    l2: l2,
    l3: l3,
    l4: l4,
    itemid: itemid,
    customer: customer,
    pageNumber: pageNumber,
    pageSize: pageSize,
    priority_group_flag:selectedPriority,
  };

  const res = cdPost(`/getCrossSellCustomerLevelData`,payload);
  return res;
}

export const useCrossSellTotalData = (
    l1: Array<any> | null,
    l2: Array<any> | null,
    l3: Array<any> | null,
    l4: Array<any> | null,
    itemid: string | null,
    customer: string | null,
    refreshStatus: boolean | false,
    selectedPriority: string | null,
  ) => {
    const { data, isLoading }: any = useQuery({
      queryKey: [
        queryKeys.reports,
        l1,
        l2,
        l3,
        l4,
        itemid,
        customer,
        refreshStatus,
        selectedPriority
      ],
      queryFn: () =>
        getCrossSellTotalData(
          l1,
          l2,
          l3,
          l4,
          itemid,
          customer,
          selectedPriority
        ),
      staleTime: 20000,
    });
    let crossellTotalData = data?.data?.records ;
  
    return { crossellTotalData, };
};
  
export function getCrossSellTotalData(
l1: Array<any> | null,
l2: Array<any> | null,
l3: Array<any> | null,
l4: Array<any> | null,
itemid: string | null,
customer: string | null,
selectedPriority: string | null,
) {
let payload = {
    l1: l1,
    l2: l2,
    l3: l3,
    l4: l4,
    itemid: itemid,
    customer: customer,
    priority_group_flag:selectedPriority,
};

const res = cdPost(`/getCrossSellTotalRecords`,payload);
return res;
}


// export const updateSKUDataRecords = (
//   updatedData: Array<any> | null,
//   categoryType: string,
//   saveStatus: boolean,
// ) => {
//   const { data, isLoading }: any = useQuery({
//     queryKey: [
//       queryKeys.reports,
//       updatedData,
//     ],
//     queryFn: () =>
//       updateCrossSellSKUData(
//         updatedData,
//         categoryType
//       ),
//     staleTime: 20000,
//     enabled: saveStatus?true:false
//   });
//   let updatedDataStatus = data?.data?.success ;
//   return { updatedDataStatus, };
// };

// export function updateCrossSellSKUData(
//   updatedData: Array<any> | null,
//   categoryType: string,
//   ) {
//   let payload = {
//       data: updatedData,
//       type: categoryType,
//   };
  
//   const res = cdPost(`/updateCrossSellSKUData`,payload);
//   return res;
//   }

export const useCrossSellItemLevelData = (
    l1: Array<any> | null,
    l2: Array<any> | null,
    l3: Array<any> | null,
    l4: Array<any> | null,
    itemid: string | null,
    customer: string | null,
    peerGroupName: string | null,
    refreshStatus: boolean | false,
    selectedPriority: string | null,
  ) => {
    const { data, isLoading }: any = useQuery({
      queryKey: [
        queryKeys.reports,
        l1,
        l2,
        l3,
        l4,
        itemid,
        customer,
        peerGroupName,
        refreshStatus,
        selectedPriority
      ],
      queryFn: () =>
        getCrossSellItemLevelData(
          l1,
          l2,
          l3,
          l4,
          itemid,
          customer,
          peerGroupName,
          selectedPriority
        ),
      staleTime: 20000,
      enabled: customer&&peerGroupName?true:false
    });
    let crossellItemLevelData = data?.data?.data ;
  
    return { crossellItemLevelData, };
  };
  
  export function getCrossSellItemLevelData(
    l1: Array<any> | null,
    l2: Array<any> | null,
    l3: Array<any> | null,
    l4: Array<any> | null,
    itemid: string | null,
    customer: string | null,
    peerGroupName: string | null,
    selectedPriority: string | null,
  ) {
    let payload = {
      l1: l1,
      l2: l2,
      l3: l3,
      l4: l4,
      itemid: itemid,
      customer: customer,
      peerGroupName:peerGroupName,
      priority_group_flag:selectedPriority,
    };
  
    const res = cdPost(`/getCrossSellItemLevelData`,payload);
    return res;
  }

  // export const useCrossSellSKULevelData = (
  //   l1: Array<any> | null,
  //   l2: Array<any> | null,
  //   l3: Array<any> | null,
  //   l4: Array<any> | null,
  //   itemid: string | null,
  //   customer: string | null,
  //   peerGroupName: string | null,
  //   selectedPriority: string | null,
  //   updatedDataStatus: boolean | false,
  // ) => {
  //   const { data, isLoading }: any = useQuery({
  //     queryKey: [
  //       queryKeys.reports,
  //       l1,
  //       l2,
  //       l3,
  //       l4,
  //       itemid,
  //       customer,
  //       peerGroupName,
  //       selectedPriority,
  //       updatedDataStatus
  //     ],
  //     queryFn: () =>
  //       getCrossSellSKULevelData(
  //         l1,
  //         l2,
  //         l3,
  //         l4,
  //         itemid,
  //         customer,
  //         peerGroupName,
  //         selectedPriority,
  //       ),
  //     staleTime: 20000,
  //     enabled: customer&&peerGroupName&&itemid?true:false
  //   });
  //   let crossellSKULevelData = data?.data ;
  
  //   return { crossellSKULevelData,  isLoadingSKUData: isLoading};
  // };
  
  // export function getCrossSellSKULevelData(
  //   l1: Array<any> | null,
  //   l2: Array<any> | null,
  //   l3: Array<any> | null,
  //   l4: Array<any> | null,
  //   itemid: string | null,
  //   customer: string | null,
  //   peerGroupName: string | null,
  //   selectedPriority: string | null,
  // ) {
  //   let payload = {
  //     l1: l1,
  //     l2: l2,
  //     l3: l3,
  //     l4: l4,
  //     itemid: itemid,
  //     customer: customer,
  //     peerGroupName:peerGroupName,
  //     priority_group_flag:selectedPriority
  //   };
  
  //   const res = cdPost(`/getCrossSellISKULevelData`,payload);
  //   return res;
  // }


  export const getCrossSellSKULevelData = (payload: any) => {
    const res = cdPost(`/getCrossSellISKULevelData`,payload);
    return res
  };

  export const updateCrossSellSKUData = (payload: any) => {
    const res = cdPost(`/updateCrossSellSKUData`,payload);
    return res;
  };


